<template>
  <vx-card title="المواد الدراسية للطالب في الفصل الحالي">
    <div v-if="student" class="flex items-center pb-4 mb-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid">
      <vs-avatar size="65px" class="border-2 cursor-default shadow border-solid border-white mt-2 mr-2 flex-shrink-0" :src="student.image"/>
      <div class="flex flex-col">
        <h4 class="mb-1">{{ student.first_name }} {{ student.middle_name}} {{ student.last_name}} </h4>
        <span>{{ student.student_id }}</span>
      </div>
    </div>
    <vs-table id="table" pagination search class="my-5" no-data-text="لا يوجد مواد دراسية" :data="courses" :total="courses.length">

      <div slot="header" class="flex flex-wrap lg:w-auto w-full">
        <vs-button @click="isFormActive = true"  color="success" icon-pack="feather" icon="icon-plus" class="lg:mt-0 mt-4 lg:ml-3 w-full lg:w-auto" icon-after>إضافة مادة دراسية</vs-button>
      </div>

      <template slot="thead">
        <vs-th>#</vs-th>
        <vs-th sort-key="id">رمز المادة</vs-th>
        <vs-th sort-key="name">إسم المادة</vs-th>
        <vs-th sort-key="description">المجموعة</vs-th>
        <vs-th sort-key="is_approved">الحالة</vs-th>
        <vs-th>العمليات</vs-th>
      </template>

      <tbody slot-scope="{data}">
        <vs-tr v-for="(tr, index) in data" :data="tr" :key="index">
          <vs-td>{{ index+1 }}</vs-td>
          <vs-td :data="tr.id">{{ tr.id }}</vs-td>
          <vs-td :data="tr.name">{{ tr.name }}</vs-td>
          <vs-td :data="tr.group">{{ tr.group }}</vs-td>
          <vs-td :data="tr.is_approved">
            <vs-chip v-if="tr.is_approved === 0" color="warning">قيد الانتظار</vs-chip>
            <vs-chip v-else color="success">مفعل</vs-chip>
          </vs-td>
          <vs-td>
            <div class="flex">
              <vs-button @click="remove(tr)" type="flat" title="حذف" color="danger" icon-after icon-pack="feather" icon="icon-trash">حذف</vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </tbody>

    </vs-table>

    <student-course-form @submit="addCourse" :active.sync="isFormActive" />
  </vx-card>
</template>

<script>
import StudentCourseForm from '@/views/admin/students/StudentCourseForm'
import studentsAPI from '@/api/admin/studentsAPI'

export default {
  name: "StudentCourses",
  components: {
    StudentCourseForm
  },
  data () {
    return {
      student: null,
      courses: [],
      isFormActive: false,
    }
  },
  computed: {
      studentName() {
        return this.student ?
            `${this.student.first_name} ${this.student.middle_name} ${this.student.last_name}`
            : ''
      },
      studentId() {
        return this.student ? this.student.student_id : ''
      },
      id() {
        return this.$route.params.student_id
      }
  },
  methods: {
    addCourse(course) {
      this.courses.push({
        id: course.course_id,
        name: course.course_name,
        group: course.group,
        is_approved: 1,
      })
    },
    remove(course){
      let message = `هل انت متأكد بأنك تريد حذف المادة ${course.name} في المجموعة ${course.group} للطالب !`;
      this.$confirmAlert(null, message, () => {
        studentsAPI.deleteCourse(this.id, course.id, course.group)
            .then(response => {
              const index = this.courses.findIndex(c => c.id === course.id)
              this.courses.splice(index, 1)
              this.$notifySuccess(response.successMessage)
            })
            .catch(response => this.$notifyError(response.statusMessage))
      })
    },
  },
  mounted () {
    this.$startLoading('#table', 'white')
    studentsAPI.getById(this.$route.params.student_id).then(({data}) => {
      this.student = data.user
      this.courses = Object.values(data.courses).map(course => ({
        id: course.id,
        name: course.name,
        group: course.groups[0] ? course.groups[0].group : '',
        is_approved: course.groups[0] ? course.groups[0].is_approved : 0
      }))
    })
    .finally(() => this.$closeLoading('#table'))
  }
}
</script>
